import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import {
  AddCircleOutline,
  HelpOutline,
  LogoutOutlined,
  SettingsOutlined,
} from '@mui/icons-material';

interface AccountMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  name: string;
  email?: string | null;
  /** "I'm also selling" / "I'm also buying"; null when nothing is hidden from the rail. */
  widenLabel?: string | null;
  onWiden?: () => void;
  onSettings: () => void;
  onContact: () => void;
  onLogout: () => void;
}

/**
 * The account actions that used to sit in the nav list as peers of Selling
 * and Today. Opened from the account block in the rail and, on desktop, the
 * avatar in the header.
 */
const AccountMenu: React.FC<AccountMenuProps> = ({
  anchorEl,
  onClose,
  name,
  email,
  widenLabel,
  onWiden,
  onSettings,
  onContact,
  onLogout,
}) => {
  const run = (action: () => void) => () => {
    onClose();
    action();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      slotProps={{ paper: { sx: { minWidth: 224, borderRadius: 2, mt: -1 } } }}
      data-testid="account-menu"
    >
      <Typography sx={{ px: 2, pt: 1, fontWeight: 700, fontSize: '0.9rem' }}>
        {name}
      </Typography>
      {email && (
        <Typography
          sx={{ px: 2, pb: 1, color: 'text.secondary', fontSize: '0.78rem' }}
          noWrap
        >
          {email}
        </Typography>
      )}
      <Divider sx={{ mb: 0.5 }} />
      {widenLabel && onWiden && (
        <MenuItem onClick={run(onWiden)}>
          <ListItemIcon>
            <AddCircleOutline fontSize="small" />
          </ListItemIcon>
          <ListItemText>{widenLabel}</ListItemText>
        </MenuItem>
      )}
      <MenuItem onClick={run(onSettings)}>
        <ListItemIcon>
          <SettingsOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText>Settings</ListItemText>
      </MenuItem>
      <MenuItem onClick={run(onContact)}>
        <ListItemIcon>
          <HelpOutline fontSize="small" />
        </ListItemIcon>
        <ListItemText>Help &amp; contact</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={run(onLogout)}>
        <ListItemIcon>
          <LogoutOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText>Log out</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default AccountMenu;
